import { createEvent, restore, sample } from 'effector'
import { persist } from 'effector-storage/session'
import { model as router } from '~/core/router'
import { getFromComeHref } from './helpers'
import { FromComeLocationEnum } from './index.h'

export const setFromComeLocation = createEvent<FromComeLocationEnum>()

export const setFromComeHref = createEvent<string | null>()
export const $fromComeHref = restore(setFromComeHref, null)

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  store: $fromComeHref,
  key: 'tria__from-come-href',
  fail: createEvent<any>(),
})

sample({
  clock: setFromComeLocation,
  source: {
    previousLocation: router.$previous,
    currentLocation: router.$location,
  },
  filter: ({ previousLocation }, currentEventType) =>
    previousLocation != null || currentEventType === FromComeLocationEnum.LEFT,
  fn: ({ previousLocation }, currentEventType) =>
    getFromComeHref({
      previousLocation,
      currentEventType,
    }),
  target: setFromComeHref,
})
